<template>
  <div class="m-cont">
    <div class="nav-sale">
      <div class="con-sal">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="home">{{ $t('home') }}</a>
        <span class="title-text">{{ $t('riepilogo') }}</span>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="controls-panel">
        <div class="calendar-card">
          <v-date-picker v-model="date" mode="date" :config="{ format: 'YYYY-MM-DD' }" />
        </div>

        <div class="cassa-card">
          <h5 class="cassa-title mb-3"><i class="fas fa-cash-register me-2"></i> Riepilogo Cassa</h5>
          
          <div class="cassa-row mb-2" v-if="totaleCommissioniDelivery > 0">
            <span class="cassa-label text-muted">Incasso Lordo Ordini:</span>
            <span class="cassa-value">€ {{ incassoLordoGiornaliero.toFixed(2) }}</span>
          </div>

          <div class="cassa-row mb-2 text-danger" v-if="totaleCommissioniDelivery > 0">
            <span class="cassa-label">Commissioni Delivery:</span>
            <span class="cassa-value">- € {{ totaleCommissioniDelivery.toFixed(2) }}</span>
          </div>

          <div class="cassa-row mb-3">
            <span class="cassa-label font-weight-bold">Incasso Netto Giornaliero:</span>
            <span class="cassa-value font-weight-bold">€ {{ incassoGiornaliero.toFixed(2) }}</span>
          </div>
          
          <div class="cassa-row mb-3">
            <span class="cassa-label">Fondo Cassa:</span>
            <div v-if="!isEditingFondoCassa" class="cassa-value-interactive" @click="editFondoCassa">
              <span>€ {{ fondoCassa.toFixed(2) }}</span>
              <i class="fas fa-pencil-alt edit-icon ms-2"></i>
            </div>
            <div v-else class="cassa-edit-group">
              <input 
                type="number" 
                step="0.01" 
                class="form-control form-control-sm cassa-input" 
                v-model="editFondoCassaValue"
                @keyup.enter="saveFondoCassa"
                @keyup.esc="cancelEditFondoCassa"
                ref="fondoCassaInput"
              />
              <button class="btn btn-success btn-xs ms-1" @click="saveFondoCassa" :disabled="savingFondoCassa">
                <i class="fas fa-check"></i>
              </button>
              <button class="btn btn-secondary btn-xs ms-1" @click="cancelEditFondoCassa" :disabled="savingFondoCassa">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          
          <hr class="cassa-divider">
          
          <div class="cassa-row total-row mt-2">
            <span class="cassa-label font-weight-bold">Totale Cassa:</span>
            <span class="cassa-value total-value text-success font-weight-bold">€ {{ totaleGiornaliero.toFixed(2) }}</span>
          </div>
        </div>

        <div class="actions-card">
          <div class="filter-group mb-4">
            <label class="d-block mb-2 font-weight-bold">Visualizzazione:</label>
            <div class="btn-group w-100 mb-2">
              <button class="btn btn-sm" :class="viewMode === 'piatti' ? 'btn-primary' : 'btn-outline-primary'" @click="viewMode = 'piatti'">Raggruppa per Piatti</button>
              <button class="btn btn-sm" :class="viewMode === 'ordini' ? 'btn-primary' : 'btn-outline-primary'" @click="viewMode = 'ordini'">Raggruppa per Ordini</button>
            </div>
          </div>

          <div class="filter-group mb-4">
            <label class="d-block mb-2 font-weight-bold">Filtra per Tipo Ordine:</label>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="filter" value="tutti" id="filterTutti">
              <label class="form-check-label" for="filterTutti">Tutti</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="filter" value="tavolo" id="filterTavolo">
              <label class="form-check-label" for="filterTavolo">Solo Tavoli</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="filter" value="asporto" id="filterAsporto">
              <label class="form-check-label" for="filterAsporto">Solo Asporto</label>
            </div>
          </div>

          <!-- Filtro pagamento (only in Ordini mode) -->
          <div class="filter-group mb-4" v-if="viewMode === 'ordini'">
            <label class="d-block mb-2 font-weight-bold">Filtra per Pagamento:</label>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="paymentFilter" value="tutti" id="payTutti">
              <label class="form-check-label" for="payTutti">Tutti</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="paymentFilter" value="contante" id="payContante">
              <label class="form-check-label" for="payContante">Contanti</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="paymentFilter" value="digitale" id="payDigitale">
              <label class="form-check-label" for="payDigitale">Digitale</label>
            </div>
          </div>

          <button class="btn btn-primary w-100 mb-3" @click="fetchData" :disabled="loading">
            <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i> {{ $t('aggiorna') }}
          </button>
          <button class="btn btn-success w-100" @click="exportToExcel" :disabled="viewMode === 'piatti' ? !items.length : !filteredOrders.length">
            <i class="fas fa-file-excel"></i> Esporta Excel
          </button>
        </div>
      </div>

      <div class="table-panel">
        <div class="glass-table-container" id="style-3">
          <!-- Piatti Table -->
          <table class="table custom-table" v-if="viewMode === 'piatti'">
            <thead>
              <tr>
                <th>{{ $t('nome_piatto') }}</th>
                <th class="text-center">{{ $t('quantita', 'Quantità') }}</th>
                <th class="text-right">Guadagno (€)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items" :key="item.piatto + '_' + item.portata">
                <td>
                  {{ item.piatto }}
                  <span v-if="item.portata" class="badge bg-secondary ms-2 text-capitalize">{{ item.portata }}</span>
                </td>
                <td class="text-center">{{ item.quantita }}</td>
                <td class="text-right">{{ item.guadagno ? item.guadagno.toFixed(2) : '0.00' }}</td>
              </tr>
              <tr v-if="!items.length && !loading">
                <td colspan="3" class="text-center text-muted py-5">
                  Nessun ordine trovato per la data selezionata.
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Ordini Table -->
          <table class="table custom-table" v-else>
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Identificativo</th>
                <th>Ora</th>
                <th>Piatti Ordinati</th>
                <th class="text-right">Sconto (€)</th>
                <th class="text-right">Totale Netto (€)</th>
                <th class="text-center">Pagamento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in filteredOrders" :key="order.id">
                <td>
                  <span :class="order.tipo === 'tavolo' ? 'badge bg-info text-dark' : 'badge bg-warning text-dark'" class="text-uppercase font-weight-bold">
                    {{ order.tipo }}
                  </span>
                  <span v-if="order.delivery" class="badge bg-primary ms-1">
                    {{ order.delivery }}
                  </span>
                </td>
                <td><strong>{{ order.identificativo }}</strong></td>
                <td>{{ order.ora }}</td>
                <td class="piatti-cell" :title="order.piatti" @click="apriDettaglioPiatti(order)">
                  {{ order.piatti }}
                </td>
                <td class="text-right">{{ order.sconto ? order.sconto.toFixed(2) : '0.00' }}</td>
                <td class="text-right">
                  <strong>€ {{ order.totale ? order.totale.toFixed(2) : '0.00' }}</strong>
                  <div v-if="order.quotaDelivery > 0" class="text-muted small" style="font-size: 0.75rem;">
                    (Lordo: € {{ order.grossTotale.toFixed(2) }} | Del: -€ {{ order.quotaDelivery.toFixed(2) }})
                  </div>
                </td>
                <td class="text-center">
                  <span :class="order.digitale ? 'badge bg-success' : 'badge bg-secondary'">
                    {{ order.digitale ? 'Digitale' : 'Contante' }}
                  </span>
                </td>
              </tr>
              <tr v-if="!filteredOrders.length && !loading">
                <td colspan="7" class="text-center text-muted py-5">
                  Nessun ordine trovato con i filtri selezionati.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Piatti Ordinati -->
  <div class="coperti-modal-overlay" v-if="showPiattiModal" @click.self="chiudiModalePiatti">
    <div class="coperti-modal-box piatti-modal-box">
      <div class="modal-header d-flex justify-content-between align-items-center mb-3">
        <h5 class="modal-title font-weight-bold" style="color: #2c3e50; font-size: 1.2rem; margin: 0;">
          <i class="fas fa-utensils me-2"></i> {{ selectedOrder ? selectedOrder.identificativo : '' }}
        </h5>
        <button type="button" class="btn-close" @click="chiudiModalePiatti" aria-label="Close" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #7f8c8d;">&times;</button>
      </div>
      <div class="modal-body" style="max-height: 400px; overflow-y: auto; text-align: left;">
        <div class="list-group">
          <div 
            v-for="(item, index) in (selectedOrder ? selectedOrder.ordinazione : [])" 
            :key="index"
            class="list-group-item list-group-item-action flex-column align-items-start py-3"
            style="border-radius: 8px; margin-bottom: 8px; border: 1px solid rgba(0,0,0,0.08); background: #fdfdfd;"
          >
            <div class="d-flex w-100 justify-content-between align-items-center mb-1">
              <h6 class="mb-1 font-weight-bold" style="color: #2c3e50; margin: 0;">
                {{ item.piatto }} 
                <span class="badge bg-secondary ms-2 text-capitalize" style="font-size: 0.75rem;" v-if="item.portata">{{ item.portata }}</span>
              </h6>
              <span class="badge bg-primary rounded-pill font-weight-bold" style="font-size: 0.9rem;">x{{ item.quantita || 1 }}</span>
            </div>
            
            <!-- Prezzo & Dettagli aggiuntivi -->
            <div class="d-flex w-100 justify-content-between text-muted mt-1" style="font-size: 0.85rem;">
              <span>Prezzo unitario: € {{ (item.prezzo || 0).toFixed(2) }}</span>
              <span class="font-weight-bold" style="color: #2ecc71;">Totale: € {{ ((item.prezzo || 0) * (item.quantita || 1)).toFixed(2) }}</span>
            </div>

            <!-- Aggiunte, Senza, Note -->
            <div v-if="(item.aggiunta && item.aggiunta.length) || (item.senza && item.senza.length) || item.nota" class="mt-2 pt-2 border-top" style="font-size: 0.8rem; border-color: rgba(0,0,0,0.05) !important;">
              <div v-if="item.aggiunta && item.aggiunta.length" class="text-success mb-1">
                <i class="fas fa-plus-circle me-1"></i> <strong>Aggiunte:</strong> {{ item.aggiunta.join(', ') }}
              </div>
              <div v-if="item.senza && item.senza.length" class="text-danger mb-1">
                <i class="fas fa-minus-circle me-1"></i> <strong>Senza:</strong> {{ item.senza.join(', ') }}
              </div>
              <div v-if="item.nota" class="text-warning">
                <i class="fas fa-comment-dots me-1"></i> <strong>Nota:</strong> {{ item.nota }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-3 pt-3 border-top d-flex justify-content-end" style="border-color: rgba(0,0,0,0.08);">
        <button type="button" class="btn btn-secondary btn-sm" @click="chiudiModalePiatti">Chiudi</button>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'
import moment from 'moment'
import * as XLSX from 'xlsx'

export default {
  name: 'RiepilogoOrdini',
  data() {
    return {
      store,
      date: new Date(),
      filter: 'tutti',
      viewMode: 'piatti',
      paymentFilter: 'tutti',
      items: [],
      ordiniTavolo: [],
      ordiniAsporto: [],
      loading: false,
      fondoCassa: 0,
      isEditingFondoCassa: false,
      editFondoCassaValue: 0,
      savingFondoCassa: false,
      showPiattiModal: false,
      selectedOrder: null,
      deliveryPlatforms: []
    }
  },
  computed: {
    filteredOrders() {
      let list = [];
      
      this.ordiniTavolo.forEach(o => {
        const gross = Math.max(0, parseFloat(o.totale || 0) - parseFloat(o.sconto || 0));
        const quotaDelivery = this.getQuotaDeliveryForRawOrder(o, gross);
        const net = Math.max(0, gross - quotaDelivery);
        list.push({
          id: o._id,
          tipo: 'tavolo',
          identificativo: `Tavolo ${o.numero} (${o.sala || ''})`,
          ora: o.tm ? moment.unix(o.tm).format('HH:mm') : '-',
          piatti: o.ordinazione ? o.ordinazione.map(p => `${p.piatto} (x${p.quantita || 1})`).join(', ') : '',
          grossTotale: gross,
          quotaDelivery: quotaDelivery,
          totale: net,
          sconto: parseFloat(o.sconto || 0),
          digitale: o.digitale === true,
          delivery: o.delivery || null,
          ordinazione: o.ordinazione || []
        });
      });

      this.ordiniAsporto.forEach(o => {
        const gross = parseFloat(o.totale || 0) / 100;
        const quotaDelivery = this.getQuotaDeliveryForRawOrder(o, gross);
        const net = Math.max(0, gross - quotaDelivery);
        list.push({
          id: o._id,
          tipo: 'asporto',
          identificativo: `Asporto - ${o.nome}`,
          ora: o.oraRitiro || '-',
          piatti: o.ordinazione ? o.ordinazione.map(p => `${p.piatto} (x${p.quantita || 1})`).join(', ') : '',
          grossTotale: gross,
          quotaDelivery: quotaDelivery,
          totale: net,
          sconto: 0,
          digitale: !!o.stripeSessionId,
          delivery: o.delivery || (o.isDelivery ? 'Delivery' : null),
          ordinazione: o.ordinazione || []
        });
      });

      if (this.paymentFilter === 'contante') {
        list = list.filter(o => !o.digitale);
      } else if (this.paymentFilter === 'digitale') {
        list = list.filter(o => o.digitale);
      }

      return list;
    },
    incassoLordoGiornaliero() {
      const totalTavoli = this.ordiniTavolo.reduce((acc, o) => {
        return acc + Math.max(0, parseFloat(o.totale || 0) - parseFloat(o.sconto || 0));
      }, 0);
      const totalAsporto = this.ordiniAsporto.reduce((acc, o) => {
        return acc + (parseFloat(o.totale || 0) / 100);
      }, 0);
      return totalTavoli + totalAsporto;
    },
    totaleCommissioniDelivery() {
      let totalComm = 0;
      this.ordiniTavolo.forEach(o => {
        const gross = Math.max(0, parseFloat(o.totale || 0) - parseFloat(o.sconto || 0));
        totalComm += this.getQuotaDeliveryForRawOrder(o, gross);
      });
      this.ordiniAsporto.forEach(o => {
        const gross = parseFloat(o.totale || 0) / 100;
        totalComm += this.getQuotaDeliveryForRawOrder(o, gross);
      });
      return totalComm;
    },
    incassoGiornaliero() {
      return Math.max(0, this.incassoLordoGiornaliero - this.totaleCommissioniDelivery);
    },
    totaleGiornaliero() {
      return this.incassoGiornaliero + this.fondoCassa;
    }
  },
  methods: {
    getQuotaDeliveryForRawOrder(o, grossTotal) {
      if (!o || !o.delivery || !this.deliveryPlatforms || !this.deliveryPlatforms.length) {
        return 0;
      }
      const platformName = String(o.delivery).trim().toLowerCase();
      const platform = this.deliveryPlatforms.find(
        p => p.nome && p.nome.trim().toLowerCase() === platformName
      );
      if (!platform) return 0;
      const perc = Number(platform.percentuale) || 0;
      const fixed = Number(platform.quotaFissa) || 0;
      const commission = (grossTotal * (perc / 100)) + fixed;
      return Math.min(grossTotal, commission);
    },
    home() {
      this.$router.push({ name: "Gestionale" })
    },
    async fetchData() {
      this.loading = true;
      const formattedDate = moment(this.date).format('YYYY-MM-DD');
      try {
        const response = await this.axios.post(this.store.path + 'riepilogo/getRiepilogo', {
          date: formattedDate,
          filter: this.filter
        }, {
          headers: {
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
          }
        });
        if (response.data) {
          const ordiniTavolo = response.data.ordiniTavolo || [];
          const ordiniAsporto = response.data.ordiniAsporto || [];
          this.ordiniTavolo = ordiniTavolo;
          this.ordiniAsporto = ordiniAsporto;
          this.fondoCassa = response.data.fondoCassa || 0;
          this.deliveryPlatforms = response.data.deliveryPlatforms || [];

          const riepilogoMap = new Map();
          const addItems = (ordinazione) => {
            if (!ordinazione) return;
            ordinazione.forEach(item => {
              const name = item.piatto;
              const qty = item.quantita || 1;
              const price = item.prezzo || 0;
              const category = item.portata || '';
              const mapKey = `${name}_${category}`;

              if (riepilogoMap.has(mapKey)) {
                const existing = riepilogoMap.get(mapKey);
                riepilogoMap.set(mapKey, {
                  ...existing,
                  quantita: existing.quantita + qty,
                  guadagno: existing.guadagno + (qty * price)
                });
              } else {
                riepilogoMap.set(mapKey, {
                  piatto: name,
                  portata: category,
                  quantita: qty,
                  guadagno: qty * price
                });
              }
            });
          };

          ordiniTavolo.forEach(order => addItems(order.ordinazione));
          ordiniAsporto.forEach(order => addItems(order.ordinazione));

          this.items = Array.from(riepilogoMap.values())
            .sort((a, b) => b.quantita - a.quantita);
        }
      } catch (error) {
        console.error("Errore caricamento riepilogo:", error);
      } finally {
        this.loading = false;
      }
    },
    editFondoCassa() {
      this.editFondoCassaValue = this.fondoCassa;
      this.isEditingFondoCassa = true;
      this.$nextTick(() => {
        if (this.$refs.fondoCassaInput) {
          this.$refs.fondoCassaInput.focus();
        }
      });
    },
    cancelEditFondoCassa() {
      this.isEditingFondoCassa = false;
    },
    async saveFondoCassa() {
      const val = parseFloat(this.editFondoCassaValue);
      if (isNaN(val)) {
        alert("Inserisci un importo valido");
        return;
      }
      this.savingFondoCassa = true;
      const formattedDate = moment(this.date).format('YYYY-MM-DD');
      try {
        const response = await this.axios.post(this.store.path + 'riepilogo/updateFondoCassa', {
          date: formattedDate,
          importo: val
        }, {
          headers: {
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
          }
        });
        if (response.data && response.data.fondoCassa !== undefined) {
          this.fondoCassa = response.data.fondoCassa;
        } else {
          this.fondoCassa = val;
        }
        this.isEditingFondoCassa = false;
      } catch (error) {
        console.error("Errore salvataggio fondo cassa:", error);
        alert("Errore durante il salvataggio del fondo cassa");
      } finally {
        this.savingFondoCassa = false;
      }
    },
    apriDettaglioPiatti(order) {
      this.selectedOrder = order;
      this.showPiattiModal = true;
    },
    chiudiModalePiatti() {
      this.showPiattiModal = false;
      this.selectedOrder = null;
    },
    exportToExcel() {
      if (this.viewMode === 'piatti') {
        if (!this.items.length) return;
        
        const data = this.items.map(item => ({
          'Piatto': item.piatto,
          'Portata': item.portata || '',
          'Quantità': item.quantita,
          'Guadagno (€)': item.guadagno ? item.guadagno.toFixed(2) : '0.00'
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Riepilogo Piatti");
        
        const fileName = `Riepilogo_Piatti_${moment(this.date).format('YYYY-MM-DD')}.xlsx`;
        XLSX.writeFile(wb, fileName);
      } else {
        const orders = this.filteredOrders;
        if (!orders.length) return;

        const data = orders.map(order => ({
          'Tipo': order.tipo.toUpperCase(),
          'Identificativo': order.identificativo,
          'Ora': order.ora,
          'Piatti': order.piatti,
          'Totale (€)': order.totale ? order.totale.toFixed(2) : '0.00',
          'Sconto (€)': order.sconto ? order.sconto.toFixed(2) : '0.00',
          'Pagamento': order.digitale ? 'DIGITALE' : 'CONTANTE'
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Riepilogo Ordini");
        
        const fileName = `Riepilogo_Ordini_${moment(this.date).format('YYYY-MM-DD')}.xlsx`;
        XLSX.writeFile(wb, fileName);
      }
    }
  },
  watch: {
    date() {
      this.fetchData();
    },
    filter() {
      this.fetchData();
    }
  },
  beforeMount() {
    this.fetchData();
  }
}
</script>

<style scoped>
.m-cont {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  color: #2d3436;
  font-family: 'Inter', sans-serif;
}

.nav-sale {
  background: rgba(44, 62, 80, 0.9);
  backdrop-filter: blur(10px);
  padding: 15px 25px;
  color: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.con-sal {
  display: flex;
  align-items: center;
  gap: 20px;
}

.title-text {
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.content-wrapper {
  display: flex;
  flex: 1;
  padding: 30px;
  gap: 30px;
  overflow: hidden;
}

.controls-panel {
  flex: 0 0 320px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  padding-right: 8px;
}

.controls-panel::-webkit-scrollbar-track {
  background-color: transparent;
}

.controls-panel::-webkit-scrollbar {
  width: 6px;
}

.controls-panel::-webkit-scrollbar-thumb {
  background-color: #2c3e50;
  border-radius: 10px;
}

.calendar-card, .actions-card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.table-panel {
  flex: 1;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.18);
  display: flex;
  flex-direction: column;
}

.glass-table-container {
  flex: 1;
  overflow-y: auto;
  border-radius: 12px;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: #2c3e50;
  color: white;
  padding: 15px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
  z-index: 10;
}

.custom-table td {
  background: white;
  padding: 15px;
  transition: transform 0.2s;
}

.custom-table tr:hover td {
  background: #f8f9fa;
  transform: scale(1.01);
}

.custom-table tr td:first-child {
  border-radius: 10px 0 0 10px;
}

.custom-table tr td:last-child {
  border-radius: 0 10px 10px 0;
}

#style-3::-webkit-scrollbar-track {
  background-color: transparent;
}

#style-3::-webkit-scrollbar {
  width: 6px;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #2c3e50;
  border-radius: 10px;
}

@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
    overflow-y: auto;
  }
  .controls-panel {
    flex: none;
    width: 100%;
    overflow-y: visible;
    padding-right: 0;
  }
}

.cassa-card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.cassa-title {
  color: #2c3e50;
  font-weight: 700;
  border-bottom: 2px solid rgba(44, 62, 80, 0.1);
  padding-bottom: 8px;
  font-size: 1.1rem;
}

.cassa-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.95rem;
}

.cassa-label {
  color: #555;
  font-weight: 500;
}

.cassa-value {
  font-weight: 600;
  color: #2d3436;
}

.cassa-value-interactive {
  font-weight: 600;
  color: #007bff;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.cassa-value-interactive:hover {
  background-color: rgba(0, 123, 255, 0.1);
}

.edit-icon {
  font-size: 0.8rem;
  opacity: 0.7;
}

.cassa-edit-group {
  display: flex;
  align-items: center;
}

.cassa-input {
  width: 90px;
  text-align: right;
  border-radius: 4px;
}

.cassa-divider {
  margin: 10px 0;
  border-color: rgba(0,0,0,0.1);
}

.total-row {
  font-size: 1.1rem;
}

.total-value {
  color: #2ecc71 !important;
}

.btn-xs {
  padding: 2px 6px;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 3px;
}

.piatti-cell {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  color: #3498db;
  text-decoration: underline;
  transition: color 0.2s;
}

.piatti-cell:hover {
  color: #2980b9;
}

.coperti-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.piatti-modal-box {
  background: #fff;
  border-radius: 15px;
  padding: 24px;
  width: 95%;
  max-width: 500px;
  box-shadow: 0 15px 35px rgba(0,0,0,0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: modal-fadeIn 0.3s ease-out;
}

@keyframes modal-fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
